import React, { useEffect } from "react";
import css from "./Branding.module.scss";
import SecOne from "./SecOne/SecOne";
import SecTwo from "./SecTwo/SecTwo";
import SecThree from "./SecThree/SecThree";
import { constants } from "assets/constants";
import { Helmet } from "react-helmet";

const Branding = () => {
    return (
        <div className={css.branding}>
            <Helmet>
                <title>{constants.titles.services_branding}</title>
                <meta name="description" content={constants.descriptions.services_branding} />
            </Helmet>
            <SecOne />
            <SecTwo />
            <SecThree />
        </div>
    );
};

export default Branding;
